<template>
  <div class="banner">
    <img v-if="banners.length === 1" :src="banners[0]" alt="">
    <swiper v-else :options="swiperOption">
      <swiper-slide v-for="(image, index) in banners" :key="index"><img :src="image" alt=""></swiper-slide>
    </swiper>
    <div class="banner-pagination">
      
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  props: {
    banners: Array
  },
  data() {
    return {
      swiperOption: {
        autoplay: true,
        pagination: {
          el: '.banner-pagination',
          bulletClass : 'bullet',
          bulletActiveClass: 'bullet-active',
        },
      },
    }
  },
  methods: {
    openDetail() {
      this.$router.push('/detail/' + (this.job.sync_jobid || this.job.jobid || '120500417')).catch(err => {
          console.log('报错：',err)
      })
    },
    enterCo(job) {
      if(job.coid) {
        this.$router.push('/company/' + job.coname)
      }
    }
  },
  components: {
    swiper, swiperSlide
  },
  created() {
    console.log(this.banners)
  }
}
</script>

<style lang="scss">
.banner {height:360px; border-radius: 8px; overflow: hidden; position: relative; font-size: 0;
  img { width: 100%; height: 100%; border-radius: 8px; }
  .banner-pagination { position: absolute; bottom: 22px; width: 100%; text-align: center; z-index: 10;
    .bullet { margin-left: 8px; display: inline-block; width:20px; height:4px; background:rgba(255,255,255,1); opacity: 0.5;
      &:first-child { margin-left: 0; }
    }
    .bullet-active { opacity: 1; }
  }
}
</style>